import { render, staticRenderFns } from "./ServiceProductList.vue?vue&type=template&id=5b84bb0d&scoped=true&"
import script from "./ServiceProductList.vue?vue&type=script&lang=js&"
export * from "./ServiceProductList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProductList.vue?vue&type=style&index=0&id=5b84bb0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b84bb0d",
  null
  
)

export default component.exports